<template>
    <div class="querySystemMyCollection">
        <div  v-if="changeFavComparePage==='收藏'">
            <common-dialog :dialog-show="fglShow" :model-obj="modelObj" @closeDialog="closeDialog">
                <template slot="title">
                    <div class="text-center" >
                    <span v-for="(item,index) in coverageData" :key="index"
                          :class="coverageData.length>1&&controllerLevel===item.levelName?'tcChange':''"
                          class="levelName display-b-i margin-right"
                          @click="changeDTab(item.levelName)">
                        {{item.levelName}}
                    </span>

                    </div>
                </template>
                <div class="contentBox ">
                    <div class="text-secondary margin-medium-y">
                        可报考的{{levelName}}专业比例：
                    </div>
                    <div class="public_scroll_bar majorLine">
                        <div v-for="(item,index) in getCoverageSonData" :key="index" class="margin-bottom delFloat position-relative">
                            <div class="float-left">{{item.majorClassName}}</div>
                            <div class="float-right">{{item.percent+'%'}}</div>
                        </div>
                    </div>
                </div>
            </common-dialog>
            <div class="delFloat" v-show="activeName==='second'">
                <el-tooltip class="item " effect="dark" content="未选择对比" v-show="compareCount<1" placement="top-start">
                    <div class="beginContrast float-right margin-top">开始对比</div>
                </el-tooltip>
                <div class="beginContrast float-right margin-top" @click="beginCompare" v-show="compareCount>0">开始对比({{compareCount}})</div>
            </div>
            <el-tabs class="tabs margin-top" type="border-card" @tab-click="handlerClick" v-model="activeName">
                <el-tab-pane name="first" label="我收藏的志愿">
                    <div class="position-relative firstTabBox" >
                        <div v-show="!firstLoading" >
                            <el-table class="margin-top" :header-cell-style="headerCellStyle"
                                      :data="volunteerList"
                                      v-loading="firstLoading"
                                      element-loading-text="拼命加载中"
                                      element-loading-spinner="el-icon-loading"
                                      element-loading-background="rgba(0, 0, 0, 0.8)"
                                      :cell-style="{'text-align':'center'}"
                            >
                                <el-table-column label="大学名称" prop="universityName"></el-table-column>
                                <el-table-column label="院校特色" prop="feature"></el-table-column>
                                <el-table-column label="院校学历层次" prop="levelName"></el-table-column>
                                <el-table-column label="专业" prop="majorName"></el-table-column>
                                <el-table-column label="子专业" prop="subMajorName"></el-table-column>
                                <el-table-column :label="title.indexOf('3')!==-1?'首选选科科目':'选科科目'" prop="firstRequire"></el-table-column>
                                <el-table-column :label="title.indexOf('3')!==-1?'首选门数要求':'门数要求'" prop="firstRequireCode"></el-table-column>
                                <el-table-column v-if="title.indexOf('6选3')===-1" label="再选科目" prop="secondRequire"></el-table-column>
                                <el-table-column v-if="title.indexOf('6选3')===-1" label="再选门数要求" prop="secondRequireCode"></el-table-column>
                                <el-table-column label="操作">
                                    <template slot-scope="scope">
                                        <el-button type="text" v-show="!scope.row.hasFav" @click="delVolunteer(scope.row.collectVolunteerId)">
                                            删除
                                        </el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <div class="text-center margin-medium-y">
                                <el-pagination layout="total, prev, pager, next, jumper"
                                               :page-size="20"
                                               :total="totalItem"
                                               :current-page.sync="currentPage"
                                               @current-change="handlerFirstPage">
                                </el-pagination>
                            </div>
                        </div>
                        <loading :show="firstLoading"></loading>
                    </div>
                </el-tab-pane>
                <el-tab-pane name="second" class="secondTabBox" label="我收藏的组合">
                    <el-row class="optionSGroup" :gutter="40" v-show="getSubjectGroupList.length>0">
                        <el-col class="kx "   :span="6"
                                :class="userGroupId===item.groupId?'activelvz':''"  v-for="(item,index) in getSubjectGroupList" :key="index">
                            <div class="subjectBox">
                                <div class="groupTitle text-ellipsis" :title="'组合'+(index+1)+':'+item.groupName" >组合{{index+1+':'}}{{item.groupName}}</div>
                                <div :title="'该组合可报考'+item.majorPercent+'%的本、专科专业'" class="text-ellipsis">{{'该组合可报考'+item.majorPercent+'%的本、专科专业'}}</div>
                                <div class="el-icon-delete" @click="cancelFavGroup(item.groupId,item.typeId)">
                                </div>
                            </div>
                            <div class="bottomData">
                                <el-button size="small" v-show="!item.isCompare" type="text" @click="addContrast(item.favId,1)">
                                    加入对比
                                </el-button>
                                <el-button size="small" v-show="item.isCompare" type="text" @click="addContrast(item.favId,2)">
                                    取消对比
                                </el-button>
                                <el-button size="small" type="text" @click="showMajorCoverage(item.groupId,item.levelId)">
                                    专业覆盖率
                                </el-button>
                                <el-button size="small" type="text" @click="reportableMajor(item.groupId,item.groupName )">
                                    可报专业
                                </el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <empty :text-size="18" content="暂无收藏的组合" :widths="150" :heights="150" v-show="getSubjectGroupList.length<1"></empty>
                </el-tab-pane>
            </el-tabs>
            <!--activeName等于1底部显示的内容-->
            <div class="bottomGroup position-relative" v-show="controllerShow&&activeName==='first'&&volunteerList.length>0">
                <div class="padding-left bottomContentBox  delFloat" v-show=" !loading">
                    <div v-for="item in getZyPpGroupList" class="float-left bGroupBox padding-x border" :key="item.groupId">
                        <div class="float-left">{{item.groupName}}</div>
                        <div class="float-right">
                            <span class="el-icon-star-off" @click="favGroup(item.groupId,item.typeId)" v-show="!item.hasFav"></span>
                            <span class="el-icon-star-on" @click="cancelFavGroup(item.groupId,item.typeId)" v-show="item.hasFav"></span>
                        </div>
                    </div>
                </div>
                <loading :show="loading" icon-width="30px" icon-height="30px"></loading>
            </div>
            <div class="bottomInfo" v-show="activeName==='first'">
                <div class="w-1200">
                    <div class="float-left">
                        你已收藏{{volunteerList.length}}个志愿，
                        有{{volunteerList.length>0?getZyPpGroupList.length:0}}个科目组合可报考这些志愿
                    </div>
                    <div class="float-right" v-show="volunteerList.length>0">
                        <el-button v-show="!controllerShow" @click="controllerShow=true">展开组合</el-button>
                        <el-button v-show="controllerShow" @click="controllerShow=false">隐藏组合</el-button>
                    </div>
                </div>
            </div>
            <common-target-router @clearHref="clearHref" :get-location="getLocation"></common-target-router>
        </div>
    </div>
</template>
<script>
    import {
        selectSubjectMajorPercent,
        selectSubjectOperateCompareGroups,
        selectSubjectSysCancelFavGroup,
        selectSubjectSysFavGroup, selectSubjectSysInfo,
        selectSubjectUserGroupList,
        selectSubjectUserVolunteerDel,
        selectSubjectUserVolunteerList, selectSubjectVolunteerGroupList
    } from "../../../../config";
    import {message} from  'element-ui'

    import {getSessionStore, setSessionStore} from "../../../../assets/static/global/global";
    export default {
        name: "querySystemMyCollection",

        data(){
          return{
              //切换展示收藏页面及对比页面
              changeFavComparePage:'收藏',
              //展示专业覆盖率
              fglShow:false,
              //设置dialog样式
              modelObj:{
                  width:'500px',
                  center:true,
                  title:''

              },
              title:'',
              activeName:'first',
              currentPage:1,
              totalItem:0,
              //志愿数据列表
              volunteerList:[],
              firstLoading:false,
              firstTableList:[],
              headerCellStyle:{
                  background: '#E7E9EA',
                  color: '#666666',
                  fontWeight: 'bolder',
                  textAlign: 'center',
              },
              getSubjectGroupList:[],
              //获取根据志愿数据匹配的组合list
              getZyPpGroupList:[],
              userGroupId:'',
              //控制是否展开组合
              controllerShow:true,
              //控制志愿列表相关的组合列表有loading效果
              loading:false,
              //控制选中本科专业还是专科专业
              controllerLevel:'本科',
              //获取本专科覆盖率内容
              coverageData:[],
              //获取本专科覆盖率子内容
              getCoverageSonData:[],
              getLocation:'',
              //关于覆盖率已选择的本科或专科
              levelName:'',
              //已加入对比的数量
              compareCount:''
          }
        },
        mounted(){
            if(this.$route.query.changePage!==undefined){
                this.showCollection();
            }
            if(getSessionStore('changeQueryCollection')){
                this.changeFavComparePage= getSessionStore('changeQueryCollection');
                this.beginCompare();
            }

            this.searchInfo();
            this.selectSubjectUserVolunteerList();
            this.searchFavGroup();
        },
        methods:{
            /*查出基本信息*/
            async searchInfo(){
                let result=await selectSubjectSysInfo();
                if(result.status){
                    this.title=result.data.title;
                }
            },
            showCollection(){
                this.changeFavComparePage='收藏';
                this.activeName='second';
                console.log(this.activeName);
            },
            //开始对比
            beginCompare(){

               this.$router.push('/stu/querySystemCompare');
            },
            closeDialog(){
              this.fglShow=false;
            },
            clearHref(){
              this.getLocation='';
            },
            /**********第二个tab下的数据**********/
            //查看可报专业
            reportableMajor(groupId,name){
                const {href}=this.$router.resolve({path:'/stu/select-subject-system',query:{groupId:groupId,groupName:name}});
                this.getLocation=href;

            },
            changeDTab(val){
                this.levelName=val;
                this.controllerLevel=val;
                let zhi=this.coverageData.filter((valSmall)=>{
                    return val===valSmall.levelName;
                })
                if(zhi.length>0){
                    this.getCoverageSonData=zhi[0].majorPercent;
                }else{
                    this.getCoverageSonData=[];
                }
            },
            //显示专业覆盖率数据
            async showMajorCoverage(groupId){
                let result=await selectSubjectMajorPercent(groupId);
                if(result.status){
                    this.coverageData=result.data;
                    this.fglShow=true;
                    this.getCoverageSonData=result.data[0].majorPercent;
                    this.levelName=result.data[0].levelName;
                    //层次名称 levelName
                    //majorPercent子级   majorClassName   percent
                }else{

                }
            },

            //加入对比
            async addContrast(favId,typeId){
                let result=await selectSubjectOperateCompareGroups(favId,typeId);
                if(result.status){
                    let messageContent='';
                    if(typeId===2){
                        messageContent='取消对比成功';
                    }else{
                        messageContent='加入对比成功';
                    }
                    message({
                        message:messageContent,
                        type:'success',
                        offset:100
                    })
                    console.log(result.data);
                    this.searchFavGroup();
                }
            },

            /**********第一个tab下的数据************/
            //收藏已选择的组合
            async favGroup(groupId,typeId){
                let result=await selectSubjectSysFavGroup(typeId,groupId);
                if(result.status){
                    console.log(result.data);

                    this.selectVolunteerAvailable();
                }
            },
            //取消收藏组合
            async cancelFavGroup(groupId,typeId){
                let result=await selectSubjectSysCancelFavGroup(typeId,groupId);
                if(result.status){
                    if(this.activeName==='first'){
                        this.selectVolunteerAvailable();
                    }else if(this.activeName==='second'){
                        this.searchFavGroup();
                    }
                }
            },
            handlerFirstPage(){
                this.selectSubjectUserVolunteerList();
            },
            handlerClick(val){
                console.log('触发了');
                this.activeName=val.name;
                console.log(val);
            },
            async delVolunteer(val){
                let result=await selectSubjectUserVolunteerDel(val);
                if(result.status){
                    console.log(result.data);
                    this.selectSubjectUserVolunteerList();
                }
            },
            //查出用户收藏的志愿数据列表
            async selectSubjectUserVolunteerList(){
                this.firstLoading=true;
                let result=await selectSubjectUserVolunteerList(this.currentPage,20);
                if(result.status){
                    this.firstLoading=false;
                    console.log('我是查出的志愿数据列表');
                    console.log(result.data.data);
                    this.totalItem=result.data.totalRecords;
                    this.volunteerList=result.data.data;
                    this.selectVolunteerAvailable();
                }else{
                    this.firstLoading=false;
                }
            },
            //查出用户收藏的志愿数据列表相关的组合列表
            async selectVolunteerAvailable(){
                this.loading=true;
              let result=await selectSubjectVolunteerGroupList();
              if(result.status){
                  this.loading=false;
                  console.log('我是志愿数据列表相关的组合列表');
                  console.log(result.data);
                  this.getZyPpGroupList=result.data;
              }else{
                this.loading=false;
              }
            },
            //查出用户收藏的学科组合
            async searchFavGroup(){
                let result=await selectSubjectUserGroupList();
                if(result.status){
                    console.log('我是收藏的组合 ');
                    console.log(result.data);
                    this.getSubjectGroupList=result.data.userFavGroups;
                    this.compareCount=result.data.compareCount;

                }
            },
        }
    }
</script>
<style lang="scss">
    .querySystemMyCollection{
        .tcChange{
            border-bottom: 3px #46c3ff solid;
            color:#46c3ff;
        }
        .contentBox{
            padding: 0 50px 0 50px;

            .majorLine{
                max-height: 400px;
                padding: 0 50px 0 50px;
            }
        }
        .levelName{
            font-size: 1.4em;
            cursor: pointer;
        }
    }
</style>
<style lang="scss" scoped>
    .querySystemMyCollection{
        .beginContrast{
            border: 1px solid dodgerblue;
            padding: 10px 20px 10px 20px;
            font-size: 1.22em;
            border-radius:5px;
            cursor: pointer;
            color:dodgerblue;
        }
        .bottomData{
            border: 1px #2b9dff dashed;
            text-align: center;
        }
        .firstTabBox{
            min-height: 400px;
            height: auto;
        }
        .secondTabBox{
            min-height: 300px;
            height:auto;
            .subjectBox{

                background: #F5FCFF;
                height: 65px;
                color: #666;
                padding: 12px 20px;
                position: relative;

                cursor: pointer;
                border-radius: 4px;
                .groupTitle{
                    font-size:1.4em;
                    color:#151515;
                }
                .el-icon-delete{
                    font-size: 20px;
                    position: absolute;
                    top:22px;
                    right: 5px;
                    font-weight: bolder;
                    color: #ffffff;
                }
            }
            .subjectBox:hover{
                animation:commonOption .4s ease-out forwards;
            }
        }

        .bottomGroup {
            min-height: 100px;
            padding-top: 10px;
            height:auto;
            position: fixed;
            z-index: 2;
            right: 0;
            width:calc(100vw - 225px) ;
            bottom:70px;
            background: #defff6;
            .bGroupBox{
                font-size: 1.3em;
                width:190px;
                height:40px;
                margin:0 10px 10px 0;
                background: #ffffff;
                border-radius: 5px;
                .float-left{
                    line-height: 40px;
                    height:40px;
                }
                .float-right{
                    line-height: 40px;
                    height:40px;
                    span{
                        cursor: pointer;
                    }
                    .el-icon-star-on{
                        color: orangered;
                    }
                }
            }
        }
        .bottomInfo{
            width:calc(100vw - 225px) ;
            right: 0;
            bottom: 0;
            position: fixed;
            z-index: 2;
            height: 70px;
            background: #1A83FF;
            font-size: 1.4em;
            color: #ffffff;
            .float-left{
                height: 70px;
                line-height: 70px;
            }
            .float-right{
                padding-top: 15px;
            }
        }
    }



</style>
